
import React, {useRef, useState, useLayoutEffect, useEffect} from 'react';
import styled from 'styled-components'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as Icons from "@fortawesome/free-brands-svg-icons"

import HeaderBackground from '../images/header-background.svg';
import logo from '../images/logo.svg';

const HeaderBlock = styled.header`
    min-height: 300px;
    margin-bottom: -20px;
    background-position: top;
    background-size: auto 980px;
    background-repeat: no-repeat;
    background-image: url(${HeaderBackground});

    @media (min-width: 768px) {
        margin-bottom: -80px;
        background-size: auto 240px;
        background-position: 70% 0%;
    }
    @media (min-width: 1150px) {
        margin-bottom: -50px;
        background-size: cover;
        background-position: bottom;
    }
`
const HeaderContainer = styled.div `
    z-index: 9;
    width: 100%;
    padding: 20px;
    display: flex;
    position: relative;
    flex-flow: column;
    box-sizing: border-box;
    pointer-events: none;
    
    @media (min-width: 768px) {
        padding: 30px;
        flex-flow: row;
    }
    @media (min-width: 1024px) {
        position: fixed;
    }
    @media (min-width: 1150px) {
        padding: 50px;
    }
`

const LogoContainer = styled.div `
    flex: 1;
    margin: 0 auto;
    max-width: 180px;
    pointer-events: all;

    @media (min-width: 1150px) {
        max-width: 220px;
    }
`

const NavContainer = styled.div `
    flex: 1;
    display: flex;
    padding: 14px 0;
    flex-flow: column;
    text-align: center;
    justify-content: center;

    @media (min-width: 768px) {
        padding: 0;
        text-align: right;
    }
`

const SocialIcons = styled.div `
    font-size: 12px;

    svg {
        padding: 10px 15px;
        pointer-events: all;
    }
`

const Navigation = styled.div `
    padding-top: 14px;

    @media (min-width: 768px) {
        padding-top: 5px;
    }
    @media (min-width: 1150px) {
        padding-top: 14px;
    }
`
const ListContainer = styled.div `
    margin: 0;
    padding: 0;
    font-size: 18px;
    list-style: none;
    line-height: 26px;

    li {
        padding: 8px 0;
        font-size: 16px;
        line-height: 22px;
    
        @media (min-width: 768px) {
            padding: 5px 0;
        }
        @media (min-width: 1150px) {
            padding: 0 0 5px;
        }

        a {
            color: #6b717f;
            cursor: pointer;
            pointer-events: all;
            text-decoration: none;

            @media (min-width: 1150px) {
                padding: 10px;
                font-size: 18px;
                display: inline-block;
            }

            &:hover {
                cursor: pointer;
            }
        }
    }
`

const Header = (props) => {
    const headerElement = useRef(null);
    const [scrollTop, setScrollTop] = useState(0);
    const [headerStyle, setHeaderStyle] = useState(0);
    const containerRef = useRef(null);
    const { callback } = props;

    useLayoutEffect(() => {
        const onScroll = e => {
          setScrollTop(e.target.documentElement.scrollTop);
        };
        window.addEventListener("scroll", onScroll);
    
        return () => window.removeEventListener("scroll", onScroll);
    }, [scrollTop]);

    const navClick = (event) => {
        event.preventDefault();

        callback(event.target.dataset.type);
    }

    useEffect(() => {
        if (scrollTop >= 250){
            setHeaderStyle(true);
        } else {
            setHeaderStyle(false);
        }
    }, [scrollTop]);

    if (headerStyle === false) {
        headerElement.current.removeAttribute("style", "mix-blend-mode: color-dodge;");
    }
    if (headerStyle) {
        headerElement.current.setAttribute("style", "mix-blend-mode: color-dodge;");
    }

    return (
        <HeaderBlock>
            <HeaderContainer ref={headerElement}>
                <LogoContainer>
                    <a href="/">
                        <img src={logo} alt="Dermatology the podcast logo"/>
                    </a>
                </LogoContainer>
                <NavContainer>
                    <SocialIcons>
                        <a href="https://open.spotify.com/show/0NxCuapxIxT3wbIJUqm0IO" target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon icon={Icons.faSpotify} size="2x" />
                        </a>
                        <a href="https://www.instagram.com/dermatologyukthepodcast/" target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon icon={Icons.faInstagram} size="2x" />
                        </a>
                        <a href="https://twitter.com/dermukpodcast" target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon icon={Icons.faTwitter} size="2x" />
                        </a>
                        <a href="https://www.facebook.com/dermatologyukthepodcast" target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon icon={Icons.faFacebook} size="2x" />
                        </a>
                    </SocialIcons>
                    <Navigation>
                        <ListContainer ref={containerRef}>
                            <li>
                                <a href="#PodcastEpisodes" onClick={(event) => navClick(event)} data-type="podcast">Listen to new episodes</a>
                            </li>
                            <li>
                                <a href="#SocialFeed" onClick={(event) => navClick(event)} data-type="social">Keep up with us</a>
                            </li>
                        </ListContainer>
                    </Navigation>
                </NavContainer>
            </HeaderContainer>
        </HeaderBlock>
    );
};

export default Header;
